"use client";

import CarGallery from "@/components/CarGallery";
import {formatDate} from "@/utils/format-date";
import Configuratore from "@/components/noleggio/Configuratore";
import ToolbarVeicolo from "@/components/ToolbarVeicolo";
import FromNoleggio from "@/components/FromNoleggio";
import React, {useRef, useState} from "react";


interface NoleggioClientProps {
    veicoloData: any
    tipoUtenteListino: string
}

export default function NoleggioClient({veicoloData, tipoUtenteListino}: NoleggioClientProps) {


    const [km, setKm] = useState('10000');
    const [durata, setDurata] = useState('48');
    const [anticipo, setAnticipo] = useState('0');
    const [cauzione, setCauzione] = useState('0');

    const getDefaultImgae = () => {
        return veicoloData.images.find((img: any) => img.defaultimage == 1)?.image ?? '/autoinarrivo.webp'
    }

    const fromNoleggioRef = useRef<HTMLDivElement>(null);

    const scrollToFromNoleggio = () => {
        if (fromNoleggioRef.current) {
            const yOffset = -150; // Offset per l'header fisso
            const y = fromNoleggioRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };



    return (
        <div className="max-w-7xl p-4 mx-auto my-[100px]">

            <div className="flex items-center  my-4 justify-between">

                <div className="max-sm:w-full">
                    <h1 className="font-bold max-sm:text-center text-4xl">{veicoloData.marca} </h1>
                    <h2 className="font-lg max-sm:text-center">{veicoloData.modello}</h2>
                    <p className="truncate max-sm:text-center text-xs">{veicoloData.supp != veicoloData.modello ? veicoloData.supp : ''}</p>
                </div>
            </div>


            <div className="p-2 bg-secondary rounded-md">

                <div className="grid grid-cols-2 max-sm:grid-cols-1 gap-x-4">

                    <div>
                        <div className="flex flex-col gap-y-4 mb-4">
                            <div className="flex max-w-max gap-x-3 max-sm:hidden">
                                <p className="bg-white px-4 h-max rounded-md text-center text-sm flex-1">KM {veicoloData.km}</p>
                                <p className="bg-white px-4 h-max rounded-md text-center text-sm flex-1 text-nowrap">{veicoloData.localita} ({veicoloData.provincia})</p>
                                <p className="bg-white px-4 h-max rounded-md text-center text-sm flex-1 text-nowrap">{veicoloData.articolo2}</p>
                            </div>

                            <div className="h-[480px] max-lg:h-[320px]">
                                <CarGallery photos={veicoloData.images} articolo={veicoloData.articolo ?? veicoloData.articolo2} />
                            </div>
                        </div>

                        <div className="grid grid-cols-4 max-sm:py-4 ">

                            <div>
                                <h4 className="text-sub text-lg max-sm:text-xs font-normal">Alimentazione</h4>
                                <p className="text-xl max-sm:text-sm font-normal">{veicoloData.alimentazione}</p>
                            </div>

                            <div>
                                <h4 className="text-sub text-lg max-sm:text-xs font-normal">Immatricolata</h4>
                                <p className="text-xl max-sm:text-sm font-normal">{formatDate(veicoloData.immatricolazione) ?? '-'}</p>
                            </div>

                            <div>
                                <h4 className="text-sub text-lg max-sm:text-xs font-normal">Chilometraggio</h4>
                                <p className="text-xl max-sm:text-sm font-normal">Km {veicoloData.km}</p>
                            </div>

                            <div>
                                <h4 className="text-sub text-lg max-sm:text-xs font-normal">Colore</h4>
                                <p className="text-xl max-sm:text-sm font-normal">{veicoloData.colore}</p>
                            </div>

                            <div>
                                <h4 className="text-sub text-lg max-sm:text-xs font-normal">Porte</h4>
                                <p className="text-xl max-sm:text-sm font-normal">{veicoloData.porte} porte</p>
                            </div>

                            <div>
                                <h4 className="text-sub text-lg max-sm:text-xs font-normal">Potenza</h4>
                                <p className="text-xl max-sm:text-sm font-normal">{veicoloData.kw} Kw
                                    - {veicoloData.cv} Cv</p>
                            </div>

                            <div>
                                <h4 className="text-sub text-lg max-sm:text-xs font-normal">Cilindrata</h4>
                                <p className="text-xl max-sm:text-sm font-normal">{veicoloData.cilindrata} cc</p>
                            </div>

                            <div>
                                <h4 className="text-sub text-lg max-sm:text-xs font-normal">Cambio</h4>
                                <p className="text-xl max-sm:text-sm font-normal">{veicoloData.cambio}</p>
                            </div>

                        </div>


                    </div>


                    <Configuratore
                        veicoloData={veicoloData}
                        tipoUtenteListino={tipoUtenteListino}
                        onChangeDurata={setDurata}
                        onChangeKm={setKm}
                        onChangeAnticipo={setAnticipo}
                        onChangeCauzione={setCauzione}
                        onScrollToFromNoleggio={scrollToFromNoleggio}/>

                </div>

            </div>


            <ToolbarVeicolo veicolo={veicoloData}/>

            <div ref={fromNoleggioRef}>
                <FromNoleggio
                    durata={durata.toString()}
                    km={km.toString()}
                    anticipo={anticipo.toString()}
                    articolo={veicoloData.articolo2}
                    marca={veicoloData.marca}
                    modello={veicoloData.modello}
                />
            </div>

            <section id="why-choose-us" className="mt-24">
                <div className="mx-auto">
                    <h5 className="text-4xl max-sm:text-center font-normal mb-4">Perché sceglierci</h5>
                </div>


                <div className="max-sm:p-4 max-sm:bg-secondary max-sm:rounded-lg">

                    <p className="text-2xl max-sm:text-center">
                        <strong>Zero penali</strong> con 35 piani variabili durante il tuo Rent to
                        Buy, <strong>a
                        tua
                        scelta,</strong> da 6 a 48 mesi <strong>fino
                        a 160.000Km</strong> <br/>

                    </p>
                    <p className="text-2xl  max-sm:text-center mt-2">
                        Possibilità di acquisto in qualsiasi momento con il <strong
                        className="text-primary">recupero
                        del 100%</strong> della <strong className="text-primary">quota
                        di ammortamento</strong> del veicolo!
                    </p>
                    <div className="grid grid-cols-2 max-sm:grid-cols-1 gap-8 mt-8">
                        <div className="flex items-center space-x-2">
                            <svg className="w-10" width="25" height="25" viewBox="0 0 25 25" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <circle cx="12.5" cy="12.5" r="12.5" fill="#7E869E" fillOpacity="0.25"/>
                                <path
                                    d="M6.81771 11.0795L11.2539 15.793C11.3132 15.856 11.4132 15.856 11.4724 15.793L23.4844 3.0303"
                                    stroke="#222222" strokeWidth="2"/>
                                <path
                                    d="M23.782 10.2714C24.2912 12.8492 23.9023 15.5237 22.6799 17.8497C21.4576 20.1757 19.4755 22.013 17.0637 23.0557C14.6518 24.0985 11.9555 24.2838 9.42366 23.5809C6.89178 22.878 4.67698 21.3292 3.14784 19.1923C1.61871 17.0554 0.867483 14.4593 1.01918 11.8361C1.17088 9.21283 2.21635 6.72063 3.98161 4.77426C5.74687 2.82789 8.12544 1.54474 10.7215 1.13836C13.3175 0.731984 15.9744 1.22689 18.25 2.54071"
                                    stroke="#222222" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                            <span className="font-medium">Prezzi più bassi del mercato nazionale</span>
                        </div>
                        <div className="flex items-center space-x-2">
                            <svg className="w-10" width="25" height="25" viewBox="0 0 25 25" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <circle cx="12.5" cy="12.5" r="12.5" fill="#7E869E" fillOpacity="0.25"/>
                                <path
                                    d="M6.81771 11.0795L11.2539 15.793C11.3132 15.856 11.4132 15.856 11.4724 15.793L23.4844 3.0303"
                                    stroke="#222222" strokeWidth="2"/>
                                <path
                                    d="M23.782 10.2714C24.2912 12.8492 23.9023 15.5237 22.6799 17.8497C21.4576 20.1757 19.4755 22.013 17.0637 23.0557C14.6518 24.0985 11.9555 24.2838 9.42366 23.5809C6.89178 22.878 4.67698 21.3292 3.14784 19.1923C1.61871 17.0554 0.867483 14.4593 1.01918 11.8361C1.17088 9.21283 2.21635 6.72063 3.98161 4.77426C5.74687 2.82789 8.12544 1.54474 10.7215 1.13836C13.3175 0.731984 15.9744 1.22689 18.25 2.54071"
                                    stroke="#222222" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                            <span
                                className="font-medium">Oltre 2.000 veicoli multi-brand in pronta consegna</span>
                        </div>
                        <div className="flex items-center space-x-2">
                            <svg className="w-10" width="25" height="25" viewBox="0 0 25 25" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <circle cx="12.5" cy="12.5" r="12.5" fill="#7E869E" fillOpacity="0.25"/>
                                <path
                                    d="M6.81771 11.0795L11.2539 15.793C11.3132 15.856 11.4132 15.856 11.4724 15.793L23.4844 3.0303"
                                    stroke="#222222" strokeWidth="2"/>
                                <path
                                    d="M23.782 10.2714C24.2912 12.8492 23.9023 15.5237 22.6799 17.8497C21.4576 20.1757 19.4755 22.013 17.0637 23.0557C14.6518 24.0985 11.9555 24.2838 9.42366 23.5809C6.89178 22.878 4.67698 21.3292 3.14784 19.1923C1.61871 17.0554 0.867483 14.4593 1.01918 11.8361C1.17088 9.21283 2.21635 6.72063 3.98161 4.77426C5.74687 2.82789 8.12544 1.54474 10.7215 1.13836C13.3175 0.731984 15.9744 1.22689 18.25 2.54071"
                                    stroke="#222222" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                            <span className="font-medium">Ritiro dell’usato con pagamento immediato o come acconto del Rent to Buy</span>
                        </div>
                        <div className="flex items-center space-x-2">
                            <svg className="w-10" width="25" height="25" viewBox="0 0 25 25" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <circle cx="12.5" cy="12.5" r="12.5" fill="#7E869E" fillOpacity="0.25"/>
                                <path
                                    d="M6.81771 11.0795L11.2539 15.793C11.3132 15.856 11.4132 15.856 11.4724 15.793L23.4844 3.0303"
                                    stroke="#222222" strokeWidth="2"/>
                                <path
                                    d="M23.782 10.2714C24.2912 12.8492 23.9023 15.5237 22.6799 17.8497C21.4576 20.1757 19.4755 22.013 17.0637 23.0557C14.6518 24.0985 11.9555 24.2838 9.42366 23.5809C6.89178 22.878 4.67698 21.3292 3.14784 19.1923C1.61871 17.0554 0.867483 14.4593 1.01918 11.8361C1.17088 9.21283 2.21635 6.72063 3.98161 4.77426C5.74687 2.82789 8.12544 1.54474 10.7215 1.13836C13.3175 0.731984 15.9744 1.22689 18.25 2.54071"
                                    stroke="#222222" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                            <span
                                className="font-medium">Rent to Buy su misura per prezzi, chilometraggio e durata</span>
                        </div>
                    </div>
                </div>

            </section>

        </div>
    )
}
